import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'app/services/guard.guard';
import { ActivitiesAuditorComponent } from './activities-auditor/activities-auditor.component';
import { ActivitiesSupervisorComponent } from './activities-supervisor/activities-supervisor.component';
import { CalificationsComponent } from './califications/califications.component';
import { MyActivitiesComponent } from './my-activities/my-activities.component';
import { MyStatusComponent } from './my-status/my-status.component';
import { ScorecardComponent } from './scorecard/scorecard.component';
import { TimelineMonitorComponent } from './timeline-monitor/timeline-monitor.component';


const routes: Routes = [
  {
    path: '',
    component: MyActivitiesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "status",
    component: MyStatusComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "scorecard",
    component: ScorecardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "activities",
    component: MyActivitiesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "supervisors",
    component: ActivitiesSupervisorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "auditors",
    component: ActivitiesAuditorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "califications",
    component: CalificationsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "timelineMonitor",
    component: TimelineMonitorComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PageRoutingModule { }
